import React, { useState } from "react";
import EnterpriseGridCommon from "./Ag-Grid";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useTranslation } from "react-i18next";
import ExclamationIcon from "../../assets/exclamation.svg";
import {
  aggridHelpers,
  COLUMN_WIDTHS,
} from "../../helpers/common/ag-grid-helper";
import { logDataHelperFunctions } from "../../helpers/logdata-helper";
import { passViewHelper } from "../../helpers/passzone/pass-zone-helper";

const PassViewAgGrid = ({
  rows,
  isLoading,
  reportColumns,
  handleRowClick,
  hideStatus,
}) => {
  const { t } = useTranslation();

  const valueRender = (params) => {
    const text = params.value;
    if (text && typeof text === "string" && text.includes("-color")) {
      return (
        <div>
          <p className="red-note-text">
            <span className="red-note">
              {Number(text.replace("-color", ""))}
            </span>
          </p>
        </div>
      );
    }
    return isNaN(text) ? "" : Number(text);
  };

  function resolveNested(obj, path) {
    return path.split(".").reduce((o, key) => (o ? o[key] : undefined), obj);
  }

  const unitsCommonFilter = {
    pivot: true,
    floatingFilter: true,
    filter: "agMultiColumnFilter",
    filterParams: {
      maxNumConditions: 1,
      filters: [
        {
          filter: "agNumberColumnFilter",
          filterParams: {
            valueFormatter: (params) => {
              return Number(
                params.value && typeof params.value === "string"
                  ? params.value.replace("-color", "")
                  : params.value || 0
              );
            },
            maxNumConditions: 1,
          },
        },
      ],
    },
    valueGetter: (params) => {
      const value = resolveNested(params.data, params.colDef.field);
      return Number(
        value && typeof value === "string"
          ? value.replace("-color", "")
          : value || 0
      );
    },
    processCellForExport: (params) => {
      return params.value && typeof params.value === "string"
        ? params.value.replace("-color", "")
        : params.value;
    },
    pivotComparator: (a, b) => b.localeCompare(a),
    cellRenderer: (params) => {
      const value = resolveNested(params.data, params.colDef.field);

      return valueRender({
        value: value,
      });
    },
  };

  const [columnDefs] = useState([
    {
      field: "sl_no",
      headerName: t("slogColumntitle.sl.no"),
      key: "sl_no",
      pivot: true,
      pivotComparator: (a, b) => b.localeCompare(a),
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      width: COLUMN_WIDTHS.small,
    },
    ...(hideStatus
      ? []
      : [
          {
            field: "status",
            headerName: t("slogColumntitle.status"),
            key: "status",
            pivot: true,
            floatingFilter: true,
            pivotComparator: (a, b) => b.localeCompare(a),
            cellRenderer: (params) => {
              return params.value
                ? logDataHelperFunctions.getIconForStatus(params.value)
                : "";
            },
            processCellForExport: (params) => {
              return params.value
                ? logDataHelperFunctions.getExportValueForStatus(params.value)
                : "";
            },
            filter: "agMultiColumnFilter",
            filterParams: {
              filters: [
                {
                  filter: "agSetColumnFilter",
                  filterParams: {
                    cellHeight: 40,
                    cellRenderer: (params) => {
                      const status = String(params.value);
                      if (status === "(Select All)") {
                        return "(Select All)";
                      }
                      return logDataHelperFunctions.getIconForStatus(status);
                    },
                    valueFormatter: (params) => {
                      return String(params.value);
                    },
                  },
                },
              ],
              maxNumConditions: 1,
            },
            width: COLUMN_WIDTHS.small,
          },
        ]),
    {
      field: "stationNumbers",
      headerName: t("slogColumntitle.stationName"),
      key: "stationNumbers",
      pivot: true,
      floatingFilter: true,
      pivotComparator: (a, b) => b.localeCompare(a),
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      width: COLUMN_WIDTHS.medium,
    },
    {
      field: "buyType",
      headerName: t("slogColumntitle.buyType"),
      key: "buyType",
      pivot: true,
      floatingFilter: true,
      pivotComparator: (a, b) => b.localeCompare(a),
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      width: COLUMN_WIDTHS.medium,
    },
    {
      field: "type",
      headerName: t("slogColumntitle.torch"),
      key: "type",
      pivot: true,
      floatingFilter: true,
      pivotComparator: (a, b) => b.localeCompare(a),
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      width: COLUMN_WIDTHS.medium,
    },
    {
      field: "name",
      headerName: t("slogColumntitle.pass"),
      key: "pass",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
      cellRenderer: (params) => {
        return params.value == "!" ? (
          <img src={ExclamationIcon} alt="Exclamation" />
        ) : (
          params.value
        );
      },
      width: COLUMN_WIDTHS.medium,
    },
    {
      field: "rawWeldStartTime",
      headerName: t("slogColumntitle.weldstartTime"),
      key: "weldStartTime",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      cellRenderer: (params) => {
        return Number(params.value) > 0
          ? logDataHelperFunctions.formatWeldStartTime(
              params.value,
              false,
              false,
              true
            )
          : "-";
      },
      processCellForExport: (params) => {
        return Number(params.value) > 0
          ? logDataHelperFunctions.formatWeldStartTime(
              params.value,
              false,
              false,
              true
            )
          : "-";
      },
      pivotComparator: (a, b) => b.localeCompare(a),
      filterParams: {
        maxNumConditions: 1,
        filters: [
          {
            filter: "agDateColumnFilter",
            filterParams: {
              comparator: (filterLocalDateAtMidnight, cellValue) => {
                return aggridHelpers.dateFilter(
                  filterLocalDateAtMidnight,
                  cellValue
                );
              },
              maxNumConditions: 1,
              inRangeInclusive: true,
              // defaultOption: 'inRange',
            },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              cellRenderer: (params) => {
                const value = String(params.value);
                if (value === "(Select All)") {
                  return "(Select All)";
                }
                return Number(params.value) > 0
                  ? logDataHelperFunctions.formatWeldStartTime(
                      params.value,
                      false,
                      false,
                      true
                    )
                  : "-";
              },

              comparator: (filterLocalDateAtMidnight, cellValue) => {
                return aggridHelpers.dateFilter(
                  filterLocalDateAtMidnight,
                  cellValue
                );
              },
            },
          },
        ],
      },
    },
    {
      field: "weld_time",
      headerName: t("slogColumntitle.weldTime"),
      key: "weld_time",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: {
              maxNumConditions: 1,
            },
          },
        ],
      },
      valueGetter: (params) => {
        const value = resolveNested(params.data, params.colDef.field);
        return isNaN(value) ? value : Number(value);
      },
      pivotComparator: (a, b) => b.localeCompare(a),
      width: COLUMN_WIDTHS.large,
    },
    {
      field: "autoIncrement",
      headerName: t("slogColumntitle.autoIncrement"),
      key: "autoIncrement",
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },

      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("slogColumntitle.current"),
      key: "currentA",
      children: [
        {
          field: "amps.low",
          headerName: t("slogColumntitle.low"),
          key: "amps_low",
          ...unitsCommonFilter,
        },
        {
          field: "amps.avg",
          headerName: t("slogColumntitle.avg"),
          key: "amps_avg",
          ...unitsCommonFilter,
        },
        {
          field: "amps.high",
          headerName: t("slogColumntitle.high"),
          key: "amps_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.volt"),
      key: "voltV",
      children: [
        {
          field: "volts.low",
          headerName: t("slogColumntitle.low"),
          key: "volts_low",
          ...unitsCommonFilter,
        },
        {
          field: "volts.avg",
          headerName: t("slogColumntitle.avg"),
          key: "volts_avg",
          ...unitsCommonFilter,
        },
        {
          field: "volts.high",
          headerName: t("slogColumntitle.high"),
          key: "volts_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.travelSpeed"),
      key: "travelSpeed",
      children: [
        {
          field: "travel.low",
          headerName: t("slogColumntitle.low"),
          key: "travel_low",
          ...unitsCommonFilter,
        },
        {
          field: "travel.avg",
          headerName: t("slogColumntitle.avg"),
          key: "travel_avg",
          ...unitsCommonFilter,
        },
        {
          field: "travel.high",
          headerName: t("slogColumntitle.high"),
          key: "travel_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.trueEnergy"),
      key: "trueEnergy",
      children: [
        {
          field: "heat.low",
          headerName: t("slogColumntitle.low"),
          key: "heat_low",
          ...unitsCommonFilter,
        },
        {
          field: "heat.avg",
          headerName: t("slogColumntitle.avg"),
          key: "heat_avg",
          ...unitsCommonFilter,
        },
        {
          field: "heat.high",
          headerName: t("slogColumntitle.high"),
          key: "heat_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.heat"),
      key: "heat",
      children: [
        {
          field: "calculated.low",
          headerName: t("slogColumntitle.low"),
          key: "calculated_low",
          ...unitsCommonFilter,
        },
        {
          field: "calculated.avg",
          headerName: t("slogColumntitle.avg"),
          key: "calculated_avg",
          ...unitsCommonFilter,
        },
        {
          field: "calculated.high",
          headerName: t("slogColumntitle.high"),
          key: "calculated_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.wireSpeed"),
      key: "wireSpeed",
      children: [
        {
          field: "wire.low",
          headerName: t("slogColumntitle.low"),
          key: "wire_low",
          ...unitsCommonFilter,
        },
        {
          field: "wire.avg",
          headerName: t("slogColumntitle.avg"),
          key: "wire_avg",
          ...unitsCommonFilter,
        },
        {
          field: "wire.high",
          headerName: t("slogColumntitle.high"),
          key: "wire_high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.oscillationWidth"),
      key: "oscillationWidth",
      children: [
        {
          headerName: t("slogColumntitle.low"),
          key: "oscillate_low",
          field: "oscillate.low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          key: "oscillate_avg",
          field: "oscillate.avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          dataIndex: ["oscillate", "high"],
          key: "oscillate_high",
          field: "oscillate.high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.frequency"),
      key: "frequency",
      children: [
        {
          headerName: t("slogColumntitle.low"),
          key: "frequency_low",
          field: "frequency.low",
        },
        {
          headerName: t("slogColumntitle.avg"),
          key: "frequency_avg",
          field: "frequency.avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          key: "frequency_high",
          field: "frequency.high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.target"),
      key: "target",
      children: [
        {
          headerName: t("slogColumntitle.low"),
          key: "target_low",
          field: "target.low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          key: "target_avg",
          field: "target.avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          key: "target_high",
          field: "target.high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.horizontalBias"),
      key: "horizontalBias",
      position: 18,
      children: [
        {
          headerName: t("slogColumntitle.low"),
          key: "horizontal_low",
          field: "horizontal.low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          key: "horizontal_avg",
          field: "horizontal.avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          key: "horizontal_high",
          field: "horizontal.high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.totalWireConsumed"),
      key: "totalWireConsumed",
      position: 19,
      children: [
        {
          headerName: t("slogColumntitle.low"),
          key: "total_low",
          field: "total.low",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.avg"),
          key: "total_avg",
          field: "total.avg",
          ...unitsCommonFilter,
        },
        {
          headerName: t("slogColumntitle.high"),
          key: "total_high",
          field: "total.high",
          ...unitsCommonFilter,
        },
      ],
    },
    {
      headerName: t("slogColumntitle.arcImpedance"),
      key: "arcImpedance",
      children: [
        {
          field: "arcImpedance.low",
          headerName: t("slogColumntitle.low"),
          key: "arcImpedance_low",
          ...unitsCommonFilter,
        },
        {
          field: "arcImpedance.avg",
          headerName: t("slogColumntitle.avg"),
          key: "arcImpedance_avg",
          ...unitsCommonFilter,
        },
        {
          field: "arcImpedance.high",
          headerName: t("slogColumntitle.high"),
          key: "arcImpedance_high",
          ...unitsCommonFilter,
        },
      ],
    },
  ]);

  const onRowClicked = (params) => {
    handleRowClick(params.data);
  };

  const processCellCallback = (params) => {
    if (params?.column?.colDef?.processCellForExport) {
      return params.column.colDef.processCellForExport(params);
    }

    return params.value;
  };

  return (
    <div className="ag-theme-alpine" style={{ width: "100%" }}>
      <EnterpriseGridCommon
        isLoading={isLoading}
        rows={rows}
        columnDefs={passViewHelper.mapPassViewColumns(
          columnDefs,
          reportColumns
        )}
        onRowClicked={onRowClicked}
        exportFileName={"pass-view"}
        processCellCallback={processCellCallback}
        heightValue={-150}
      />
    </div>
  );
};

export default PassViewAgGrid;
